import { Component, OnInit } from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {WebappService} from '../webapp.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-manage-brands',
  templateUrl: './manage-brands.component.html',
  styleUrls: ['./manage-brands.component.css']
})
export class ManageBrandsComponent implements OnInit {
  rows = [];
  isAdd=true;

  tempData = {
    name:"",
    slug:"",
    image:{
      id:1,
      thumbnail:"",
      original:""
    }
  };
  initialData = {
    name:"",
    slug:"",
    image:{
      id:1,
      thumbnail:"",
      original:""
    }
  }

  private notifier: NotifierService;

  constructor(private serviceClass: WebappService, private activatedRoute: ActivatedRoute, private router: Router, notifier: NotifierService) {
    this.notifier = notifier;
  }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.updateTableData();
  }

  updateTableData(){
    this.serviceClass.getAllBrands().subscribe(
        data => {
          this.rows = data;
        }
    );
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  resetThePage() {
    window.location.reload();
  }

  openWidgetForAdd() {
    this.isAdd = true;
    this.tempData = this.initialData;
    document.getElementById("dataModelBtn").click()
  }

  openWidgetForEditing(data: any) {
    this.isAdd = false;
    this.tempData = data;
    document.getElementById("dataModelBtn").click()
  }

  deleteProduct(data:any) {
    if(confirm("Do you want to delete this item? ("+data.name+")")) {
      this.serviceClass.deleteBrands(data).subscribe(
          data => {
            this.updateTableData();
            this.showNotification("success", "Deleted successfully!")
          }
      );
    }
  }

  updateChanges() {
    if(this.isAdd){
      this.serviceClass.addBrands(this.tempData).subscribe(
          data => {
            this.updateTableData();
            document.getElementById("dataModelBtnClose").click()
            this.showNotification("success", "Added successfully!")
          }
      );
    } else {
      this.serviceClass.updateBrands(this.tempData).subscribe(
          data => {
            this.updateTableData();
            document.getElementById("dataModelBtnClose").click()
            this.showNotification("success", "Updated successfully!")
          }
      );
    }
  }


  // @ts-ignore
  cloudinary = cloudinary.createUploadWidget(this.serviceClass.cloudinaryArray[Number(localStorage.getItem('imageCount')) % this.serviceClass.numOfCloudinaryAccounts], (error, result) => {
        if(result.info.thumbnail_url != null) {
          this.tempData.image.original = result.info.secure_url;
          this.tempData.image.thumbnail = result.info.secure_url;
        }
      }
  )
  uploadPrimaryImage() {
      if(localStorage.getItem('imageCount')){
          this.cloudinary.open();
          localStorage.setItem('imageCount', (Number(localStorage.getItem('imageCount')) + 1).toString())
      } else {
          localStorage.setItem('imageCount','1')
          this.cloudinary.open();
      }
  }
}
